module.exports = "/static/assets/f011f09e649e804c4c0c8275a7d1ba5b.png";